import { ILiveActivity } from 'features/eiq-secure/stores/live-activity/live-activity.types';
import { ServerClient } from '../../utils/http/http-clients';

class LiveActivityService {
  async getLastLiveActivityByGate(gate?: string | null): Promise<ILiveActivity[]> {
    const res = await ServerClient.get<ILiveActivity[]>('/live-activity', {
      params: {
        gate: gate,
      },
    });

    return res?.data;
  }
}

export const liveActivityService = new LiveActivityService();
export default liveActivityService;
